import { render, staticRenderFns } from "./BaseContentPages.vue?vue&type=template&id=05e3e6b5&"
import script from "./BaseContentPages.vue?vue&type=script&lang=ts&"
export * from "./BaseContentPages.vue?vue&type=script&lang=ts&"
import style0 from "./BaseContentPages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports